import React,{useState, useRef} from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import SegmentDetail from "./SegmentDetailKiwi";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import IconClose from '@material-ui/icons/Close';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  backgroundColor:'var(--white)',
  border: '2px solid #000',
  color:'var(--darker)',
  boxShadow: 24,
  p: 3,
};
const useStyles = makeStyles((theme) => ({
    paper: {
      height: 140,
      width: 100,
backgroundColor:'var(--white)'
    },
    control: {
      padding: "2%",
      marginBottom: "2%",
      backgroundColor:'var(--white)'
    },
    main: {
      paddingTop: "10%",
      // backgroundColor: "rgb(246, 249, 252)",
      minHeight: "100vh",
      [theme.breakpoints.down("sm")]: {
        paddingTop: "32%",
      },
    },
  }));
function SelectedFlight(props){
    // const [showDetail,setShowDetail]=useState(false)
    const [open, setOpen] = React.useState(false);
    const handleOpen = (e) =>{
       e.stopPropagation();
       setOpen(true)};
    const handleClose = (e) => {
      e.stopPropagation();
      setOpen(false);
    }
  
    const {flight}=props;
    return(<>
    
  <Grid item xs="12" style={{paddingBottom:0,marginTop:'10px'}}>
   
                <>
                <a style={{padding:'8px',backgroundColor:'var(--backgroundcolor)',color:'var(--darker)',borderRadius:'50%'}} onClick={handleOpen}>
                      {open?<ExpandLessIcon/>:
                    <ExpandMoreIcon />}
                    </a>
                    <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        
        <Box sx={style}>
          <div style={{overflowY:'scroll',height:'500px'}}>
          <div style={{textAlign:'right'}} onClick={handleClose}><span style={{fontSize:'16px',color:' var(--lighttextcolor)',padding:'5px'}} ><IconClose/></span></div>
                  <Grid container >
                    { flight&&flight.slices.map((airport) =>                   
                    airport&&airport.segments&&airport.segments.map((segment, index) => {
                      return (
                        <>                                        
                        <SegmentDetail
                          segment={segment}
                          index={index}
                          segments={airport.segments}
                        /> </>
                      );
                    })                  
                  )}
                  </Grid></div>
                  </Box>
      </Modal></>
      </Grid>
  </>)
}
export default React.memo(SelectedFlight)

SelectedFlight.defaultProps = {
  showHeading:true
}

